import React from "react";
import {
    InformfixService,
    HomeService,
    ProjectService,
    AuthService,
    JobService,
} from "./../../services";
import {
    List,
    Avatar,
    Button,
    Skeleton,
    Modal,
    Select,
    Row,
    Col,
    Input,
    message,
    Dropdown,
    Menu,
    Popconfirm,
    Form,
    Card,
    PageHeader,
    Divider,
    notification,
    Tooltip,
    Space,
    Spin,
    Tabs,
    Table,
    Tag,
    Badge,
    DatePicker,
    Pagination,
} from "antd";
import { Config } from "./../../config";
import iconHome from "./../../assets/images/informfix/icon-home.png";
import PaginationDetail from "../../components/PaginationDetail";
import queryString from "query-string";
import { Moment } from "./../../helpers";
import { observer, inject } from "mobx-react";

import { SearchOutlined, WifiOutlined } from "@ant-design/icons";

import "./InformfixPendingPage.scss";
import { JobDateTime } from "../../components/job/JobDateTime";
import JobProceed from "../../components/job/job-proceed";
import InformListComponent from "../../components/informfix/InformListComponent";

const IconText = ({ icon, text, onClickAction }) => (
    <React.Fragment>
    {icon} {text}
  </React.Fragment>
);

const { Option } = Select;

const openNotificationWithIcon = (type, message, description = "") => {
    notification[type]({
        message: message ? message : "Notification Title",
        description: description,
    });
};
const formatDateSearch = "DD/MM/YYYY";
const STATUS_INFORMFIX_OPEN = Config.informfix.status.OPEN.value; //  สถานะใบแจ้งซ่อม: เปิดงาน
// const STATUS_INFORMFIX_WAIT = Config.informfix.status.WAIT.value; //  สถานะใบแจ้งซ่อม: รอยืนยันลูกค้า
// const STATUS_INFORMFIX_CONFIRMED = Config.informfix.status.CONFIRMED.value; //  สถานะใบแจ้งซ่อม: ยืนยันลูกค้าแล้ว
const STATUS_INFORMFIX_PROCEED = Config.informfix.status.PROCEED.value; // สถานะใบแจ้งซ่อม: กำลังดำเนินการ  สำหรับใช้แสดงหน้าจัดคิวงาน
const STATUS_INFORMFIX_COMPLETE = Config.informfix.status.COMPLETE.value; //  สถานะใบแจ้งซ่อม: เสร็จแล้ว
const STATUS_INFORMFIX_CANCEL = Config.informfix.status.CANCELED.value; //  สถานะใบแจ้งซ่อม: ยกเลิก
const STATUS_INFORMFIX_REJECTED = Config.informfix.status.REJECTED.value; //  สถานะใบแจ้งซ่อม: ปฏิเสธ

@inject("informStore")
@observer
class InformfixTaskAginPage extends React.Component {
    constructor() {
        super();
        this.state = {
            initLoading: true,
            loading: false,
            loadingProject: false,
            data: [],
            list: [],
            showFormView: false,
            showFormAdd: false,
            showFormEdit: false,
            showFormAssign: false,
            showFormNotification: false,
            countWorkstatus: [],
            countInformPostpone: 0,
            count4task: 0,
            editId: "",
            viewId: "",
            workStatus: "",
            searchParams: {
                step_work: "",
                project_id: "",
                work_status: "",
                postpone_mark: 1,
                q: "",
                f: "home_no",
            },
            pagination: {
                current: 1,
                total: 0,
                pageSize: Config.pager.limit,
                pageCount: 0,
            },
            homeDetail: {},
            inform: {},
            galleries: [],
            photos: [],
            visibleHomeDetail: false,
            confirmLoading: false,
            projects: [],
            listStatus: [],
            listJobStatus: [],
        };
    }

    formRef = React.createRef();

    setPageParams(params) {
        this.setState({
            pagination: {
                current: params.currentPage,
                total: params.totalCount,
                pageSize: params.perPage,
                pageCount: params.pageCount,
            },
        });
    }

    /**
     * แสดงข้อมูลตาม Filter ที่เลือกไว้
     */
    getData = () => {
        const { searchParams, pagination } = this.state;
        const params = {
            page: pagination ? pagination.current : 1,
            "per-page": pagination ? pagination.pageSize : Config.pager.limit,
            // project_id: searchParams.project_id,
            // work_status: searchParams.work_status,
            f: searchParams.f,
            q: searchParams.q,
            // step_work: searchParams.step_work,
            postpone_mark: searchParams.postpone_mark,
        };
        this.props.informStore.setItems([]);
        this.setState({
            pagination: {
                current: 1,
                total: 0,
                pageSize: Config.pager.limit,
                pageCount: 0,
            },
        });
        return InformfixService.search(params);
    };

    /**
     * ดึงข้อมุลใบแจ้งซ๋อมแบบเริ่มที่หน้า 1 และรีเซ็ต Filter ใหม่หมด
     */
    getItems = () => {
        let pagination = { ...this.state.pagination };
        pagination.current = 1;
        pagination.total = 0;
        pagination.pageSize = Config.pager.limit;
        pagination.pageCount = 0;
        this.setState({
            initLoading: true,
        });
        this.state.pagination.current = 1;
        this.getData()
            .then((rs) => {
                const data = rs.data["items"];
                const pager = rs.data["_meta"];
                this.setPageParams(pager);
                this.props.informStore.setItems(data);
                this.setState({
                        loading: false,
                        data: data,
                        list: data,
                        initLoading: false,
                    },
                    () => {
                        window.dispatchEvent(new Event("resize"));
                    }
                );
                this.props.informStore.setItems(data);
            })
            .catch((err) => {
                if (err.response) {
                    const code = err.response.status;
                    console.log(err.response);
                    if (code === 404) {
                        message.warning(err.response.statusText);
                    }
                }
                this.setState({ initLoading: false, loading: false });
            });
    };
    /**
     * สำหรับปุ่มค้นหาแสดงเริ่มต้นที่หน้า 1 และ filter อื่น ๆ ยังคง filter อื่น ๆ ไว้
     */
    onSearch = () => {
        this.setState({
            list: [],
        });
        this.getItems();
        this.setQueryString();
        this.getCountWorkStatus();
        this.getCountInformPostpone();
        this.getCountInform4task();
    };

    /**
     * ดึงข้อมุลใบแจ้งซ๋อมตามหน้าที่กำหนด
     */
    loadDataPagination = () => {
        this.setState({
            initLoading: true,
        });
        this.getData()
            .then((rs) => {
                const data = rs.data["items"];
                const pager = rs.data["_meta"];
                this.props.informStore.setItems(data);
                this.setPageParams(pager);
                this.props.informStore.setItems(data);
                this.setState({
                        data: data,
                        list: data,
                        initLoading: false,
                    },
                    () => {
                        window.dispatchEvent(new Event("resize"));
                    }
                );
            })
            .catch((err) => {
                if (err.response) {
                    const code = err.response.status;
                    console.log(err.response);
                    if (code === 404) {
                        message.warning(err.response.statusText);
                    }
                }
                this.setState({ initLoading: false });
            });
    };

    /**
     * ข้อมูลสถานะแจ้งซ่อมทั้งหมด
     */
    getWorkStatus() {
        InformfixService.getWorkStatus().then((rs) => {
            if (rs) {
                const data = rs.data["data"];
                this.setState({ listStatus: data });
            }
        });
    }
    /**
     * ข้อมูลสถานะใบแจ้งซ่อมที่มีการแจ้งเตือนให้เลื่อน
     */
    getCountInformPostpone() {
        InformfixService.countPostpone().then((rs) => {
            if (rs) {
                console.log("postpone", rs.data);
                const data = rs.data;
                this.setState({ countInformPostpone: data });
                this.props.informStore.countPostpone = data.total;
            }
        });
    }
    /**
     * ข้อมูลสถานะใบแจ้งซ่อมที่มีแจ้งเตือนให้เลื่อนคิวนัดหมายใหม่
     */
    getCountInform4task() {
        InformfixService.count4task().then((rs) => {
            console.log("count4task", rs);
            if (rs) {
                const data = rs.data;
                this.setState({ count4task: data });
                this.props.informStore.count4task = data.total;
            }
        });
    }
    /**
     * ข้อมูลสถานะคิวงานแจ้งซ่อม
     */
    getJobStatus() {
        JobService.getJobStatus().then((rs) => {
            if (rs) {
                const data = rs.data["data"];
                this.setState({ listJobStatus: data });
            }
        });
    }
    /**
     * ข้อมูลสถานะคิวงานแจ้งซ่อม
     */
    getCountWorkStatus() {
        const searchParams = this.state.searchParams;
        let condition = "manage_appoinments";
        if (STATUS_INFORMFIX_OPEN == searchParams.work_status) {
            condition = "manage_appoinments";
        }
        InformfixService.countWorkstatus({ for: condition }).then((rs) => {
            if (rs) {
                const data = rs.data;
                this.setState({ countWorkstatus: data });
            }
        });
    }

    /**
     * ข้อมูลโครงการทั้งหมด
     */
    getProjects() {
        this.setState({
            loadingProject: true,
        });
        ProjectService.all().then((pj) => {
            if (pj) {
                const dataProject = pj.data["data"];
                this.setState({ projects: dataProject });
                this.setState({
                    loadingProject: false,
                });
                this.getData().then((rs) => {
                    const data = rs.data["items"];
                    const pager = rs.data["_meta"];
                    this.setState({
                        initLoading: false,
                        data: data,
                        list: data,
                    });
                    this.setPageParams(pager);
                });
            }
        });
    }

    componentDidMount() {
        // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
        this.getProjects();

        // โหลดข้อมูลสถานะใบแจ้งซ่อม
        this.getWorkStatus();

        // โหลดข้อมูลสถานะคิวงานทั้งหมด
        this.getJobStatus();

        this.getCountWorkStatus();

        const qry = queryString.parse(this.props.location.search);

        if (qry.project_id) {
            this.state.searchParams.project_id = qry.project_id;
            this.formRef.current.setFieldsValue({
                project_id: qry.project_id,
            });
        }

        if (qry.f) {
            this.state.searchParams.f = qry.f;
            this.formRef.current.setFieldsValue({
                f: qry.f,
            });
        }
        if (qry.postpone_mark) {
            this.state.searchParams.postpone_mark = qry.f;
            this.formRef.current.setFieldsValue({
                postpone_mark: qry.postpone_mark,
            });
        }
        if (qry.f == "date") {
            this.state.searchParams.q = qry.q;
            if (qry.q) {
                this.formRef.current.setFieldsValue({
                    q: Moment(qry.q).utc(7),
                });
            }
        } else {
            this.state.searchParams.q = qry.q;
            this.formRef.current.setFieldsValue({
                q: qry.q,
            });
        }

        const searchParams = this.state.searchParams;
        searchParams.postpone_mark = 1;
        this.setState({ searchParams });
        this.onSearch();
    }

    onChangeProject = (value) => {
        let searchParams = this.state.searchParams;
        searchParams.project_id = value;
        this.setState({
            searchParams,
        });
        this.setQueryString();
    };
    // onChangeWorkStatus = (value) => {
    //   let searchParams = state.searchParams
    //   searchParams.work_status = value
    //   this.setState({
    //     searchParams,
    //   })
    //   this.setQueryString()
    // }

    onChangeSearchFeild = (value) => {
        this.formRef.current.setFieldsValue({
            q: null,
        });
        let searchParams = this.state.searchParams;
        searchParams.f = value;
        const nowDate = Moment().utc(7).format("YYYY-MM-DD");
        if (value == "date") {
            searchParams.q = null;
            this.formRef.current.setFieldsValue({
                q: null,
            });
        } else {
            searchParams.q = null;
        }
        this.setState({
            searchParams,
        });
        this.setQueryString();
    };

    onChangeQ = (e) => {
        e.persist();
        let searchParams = this.state.searchParams;
        if (searchParams.f == "date") {} else {
            searchParams.q = e.target.value;
        }
        this.setState({
            searchParams,
        });
        this.setQueryString();
    };
    onChangDate = (value) => {
        let searchParams = this.state.searchParams;
        const date = Moment(value).utc(7).format("YYYY-MM-DD");
        console.log("date", date);
        if (Moment(value).isValid()) {
            searchParams.q = date;
        } else {
            searchParams.q = null;
        }
        this.setState({
            searchParams,
        });
        this.setQueryString();
    };

    setQueryString() {
        let params = queryString.stringify(this.state.searchParams);
        this.props.history.push({
            search: params,
        });
    }

    resetForm() {
        this.formRef.current.resetFields();
        this.setState({
            data: [],
            list: [],
            searchParams: {
                project_id: "",
                work_status: "",
                q: "",
                f: "home_no",
            },
            pagination: {
                current: 1,
                total: 0,
                pageSize: this.state.pagination.perPage,
                pageCount: 0,
            },
        });
        const { form } = this.props;
        this.onSearch();
    }

    updateListInformfix = (row) => {
        const informfix = row;
        let list = this.props.informStore.getItems;
        if (informfix) {
            list.map((i, index) => {
                if (i.id == informfix.id) {
                    list[index] = informfix;
                }
            });
            this.props.informStore.setItems(list);
            this.setState({
                list: list,
            });
        }
    };
    /**
     * ยกเลิกแจ้งซ่อม
     */
    cancelInform = (item) => {
        InformfixService.cancel(item.id).then((rs) => {
            if (rs) {
                const inform = rs.data.data;
                this.updateListInformfix(inform);
                openNotificationWithIcon("success", rs.data["message"]);
            }
        });
    };
    /**
     * เปลี่ยนสถานะใบแจ้งซ่อม
     */
    setWorkStatus = (item, status) => {
        if (status.value != undefined) {
            this.setQueryString();
            InformfixService.setWorkStatus(item.id, {
                workstatus: status.value,
            }).then((rs) => {
                const inform = rs.data.data;
                this.updateListInformfix(inform);
                openNotificationWithIcon("success", rs.data["message"]);
            });
        }
    };

    // *******************************end addition **********************************

    /**
     * เปลี่ยน Tabs
     */
    tabChange = (key, showPostpone) => {
        console.log("key", key);
        let searchParams = this.state.searchParams;

        searchParams.step_work = "";
        searchParams.postpone_mark = "";

        if (showPostpone) {
            searchParams.work_status = "";
            searchParams.postpone_mark = 1;
        } else {
            searchParams.work_status = key;
            if (key == STATUS_INFORMFIX_OPEN) {
                searchParams.step_work = "add_appointments";
            }
        }

        if (searchParams.f == "date") {
            searchParams.q = null;
        }

        this.setState({
            searchParams: searchParams,
        });
        this.formRef.current.setFieldsValue({
            work_status: searchParams.work_status,
            q: searchParams.q,
        });
        this.onSearch();
    };

    /**
     *
     */
    listInformPostpone = (key) => {
        console.log("key", key);
        let searchParams = this.state.searchParams;
        searchParams.work_status = "";
        searchParams.step_work = "";
        searchParams.postpone_mark = "";
        searchParams.postpone_mark = 1;
        if (searchParams.f == "date") {
            searchParams.q = null;
        }
        this.setState({
            searchParams: searchParams,
        });
        this.formRef.current.setFieldsValue({
            work_status: searchParams.work_status,
            q: searchParams.q,
        });
        this.onSearch();
        this.getCountInformPostpone();
        this.getCountInform4task();
    };

    render() {
        const {
            initLoading,
            loading,
            pagination,
            projects,
            searchParams,
        } = this.state;
        const { items } = this.props;

        const { TabPane } = Tabs;

        const layoutForm = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };

        /**
         * ฟอร์มค้นหาใบแจ้งซ่อม
         */
        const searchInformForm = (
            <React.Fragment>
        <Form
          ref={this.formRef}
          initialValues={{
            q: searchParams.q,
            f: searchParams.f,
            work_status: searchParams.work_status,
          }}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
          layout="horizontal"
          size="small"
        >
          <Form.Item name="project_id" label="โครงการ">
            {projects ? (
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="-เลือกโครงการ-"
                filterOption={true}
                // optionFilterProp="children"
                onChange={this.onChangeProject}
                // filterOption={(input, option) =>
                //   option.props.children
                //     .toLowerCase()
                //     .indexOf(input.toLowerCase()) >= 0
                // }
              >
                {projects.map((p, index) => (
                  <Option key={index} value={p.id}>
                    {p.name}
                  </Option>
                ))}
                {/* <Option value="1">วันที่แจ้ง</Option>
                         <Option value="2">บ้านเลขที่</Option>
                         <Option value="3">แปลงบ้าน</Option>
                         <Option value="5">ชื่อผู้แจ้ง</Option>
                         <Option value="5">ID</Option> */}
              </Select>
            ) : null}
          </Form.Item>
          <Form.Item name="f" label="ค้นหาจาก">
            <Select
              placeholder="-ประเภทคำค้นหา-"
              style={{ width: "100%" }}
              onChange={this.onChangeSearchFeild}
              allowClear
            >
              <Option value="date">วันที่แจ้ง</Option>
              <Option value="home_no">บ้านเลขที่</Option>
              <Option value="plan_no">แปลงบ้าน</Option>
              <Option value="informer">ชื่อผู้แจ้ง</Option>
              <Option value="id">ID</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="q"
            label={
              this.state.searchParams.f == "date" ? "วันที่แจ้ง" : "คำค้นหา"
            }
          >
            {/* <Input
        placeholder="คำค้นหา.."
        onChange={this.onChangeQ}
        onPressEnter={this.onSearch}
        allowClear
      /> */}
            {searchParams.f == "date" ? (
              <DatePicker
                placeholder="เลือกวันที่"
                format={formatDateSearch}
                onChange={this.onChangDate}
                allowClear={true}
              />
            ) : (
              <Input
                placeholder="คำค้นหา.."
                onChange={this.onChangeQ}
                onPressEnter={this.onSearch}
                allowClear
              />
            )}
          </Form.Item>
          <Form.Item wrapperCol={{ ...layoutForm.wrapperCol, offset: 4 }}>
            <Button
              type="primary"
              loading={loading || initLoading}
              disabled={loading || initLoading}
              shape="circle"
              onClick={this.onSearch}
              title="ค้นหา"
              icon={<SearchOutlined />}
            ></Button>
          </Form.Item>
        </Form>
      </React.Fragment>
        );

        const conditionShowCountStatus = (item, key) => {
            if (item.work_status == STATUS_INFORMFIX_OPEN) {
                return (
                    <Badge
            count={
              this.state.count4task && this.state.count4task.total > 0
                ? this.state.count4task.total
                : 0
            }
            key={key}
          />
                );
            } else {
                return <Badge count={item.total} key={key} />;
            }
        };
        const showTotalStatus = (status) => (
            <React.Fragment>
        {this.state.countWorkstatus.map((item, key) =>
          status == item.work_status
            ? conditionShowCountStatus(item, key)
            : null
        )}
      </React.Fragment>
        );

        const filterStatusForShow = (i, key) => {
            return (
                <Button
          onClick={() => this.tabChange(i.value)}
          key={key}
          size="small"
          icon={<WifiOutlined />}
        >
          {i.text}
          {i.value == STATUS_INFORMFIX_OPEN ||
        //   i.value == STATUS_INFORMFIX_WAIT ||
        //   i.value == STATUS_INFORMFIX_CONFIRMED ||
          i.value == STATUS_INFORMFIX_PROCEED
            ? showTotalStatus(i.value)
            : null}
        </Button>
            );
        };

        return (
            <React.Fragment>

        <PageHeader title="รอเปลี่ยนวันนัดหมาย">
            <div style={{ margin: "10px 0" }}> {searchInformForm}</div>
       
            <PaginationDetail data={this.state.pagination} />

            <InformListComponent
              items={this.props.informStore.getItems}
              showMenu={{
                manageTask: true,
                confirmJob: true,
                closeInform: true,
                reconfirmInform: true,
              }}
              onWorkstatusChange={(data) => {
                this.getCountWorkStatus();
                this.getCountInformPostpone();
                this.getCountInform4task();
              }}
              showFormAdd={this.state.showFormAdd}
              onFormAddClose={(value) => {
                this.setState({
                  showFormAdd: value,
                });
                this.getCountWorkStatus();
                this.getCountInformPostpone();
                this.getCountInform4task();
              }}
              manageTask
            />
            <PaginationDetail data={pagination} />
            <Pagination
              showQuickJumper
              defaultCurrent={1}
              current={this.state.pagination.current}
              total={this.state.pagination.total}
              pageSize={this.state.pagination.pageSize}
              onChange={(page, pageSize) => {
                let pagination = this.state.pagination;
                pagination.current = page;
                pagination.pageSize = pageSize;
                this.setState({
                  pagination,
                });
                this.loadDataPagination();
              }}
              onShowSizeChange={(page, pageSize) => {
                let pagination = this.state.pagination;
                pagination.current = page;
                pagination.pageSize = pageSize;
                this.setState({
                  pagination,
                });
                this.loadDataPagination();
              }}
            />
      </PageHeader>
      </React.Fragment>
        );
    }
}

export default InformfixTaskAginPage;